import { render } from "./CategoriasAdminView.vue?vue&type=template&id=52bfbcd8&ts=true"
import script from "./CategoriasAdminView.vue?vue&type=script&lang=ts"
export * from "./CategoriasAdminView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__